function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M875.74982,529.19691a10.05579,10.05579,0,0,1,4.89934-14.62027l-1.4214-35.70656,15.89673,9.59831-1.08735,32.436a10.11027,10.11027,0,0,1-18.28732,8.29248Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#a0616a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M896.96714,506.04938l-14.13241,2.258a4.49982,4.49982,0,0,1-5.17019-3.85125l-5.97915-45.0295-29.54482-40.43167a13.57917,13.57917,0,0,1,3.6527-19.45295l-.001-.00009a13.57859,13.57859,0,0,1,18.7536,4.13l30.17438,47.21821,6.0057,50.18109a4.55393,4.55393,0,0,1,.01317.96485A4.48579,4.48579,0,0,1,896.96714,506.04938Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ff7e67"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "626.725 459.863 614.465 459.863 608.633 412.575 626.727 412.576 626.725 459.863",
  fill: "#a0616a"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M605.70782,456.35988h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H590.821a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,605.70782,456.35988Z",
  fill: "#2f2e41"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "678.45 438.879 669.29 447.027 635.145 413.36 647.021 403.547 678.45 438.879",
  fill: "#a0616a"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M885.77919,658.75819h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H870.89234a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,885.77919,658.75819Z",
  transform: "translate(-439.24026 546.75064) rotate(-41.65452)",
  fill: "#2f2e41"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M725.04291,402.777a10.05579,10.05579,0,0,1,12.32413,9.26669l34.32739,9.9302-14.12827,12.051L727.1343,422.7474a10.11027,10.11027,0,0,1-2.09139-19.97042Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#a0616a"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 610.54695,
  cy: 130.6278,
  r: 24.56103,
  fill: "#a0616a"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M849.74968,664.32848,832.686,662.96324a4.49731,4.49731,0,0,1-4.13867-4.33691l-4.7627-143.833a4.48928,4.48928,0,0,1,3.87573-4.60547l34.01978-4.74707a4.49957,4.49957,0,0,1,5.05762,5.21387l-13.01807,76.249a3.51377,3.51377,0,0,0-.0498.63477l.93847,72.24512a4.50116,4.50116,0,0,1-4.50268,4.55957C849.98723,664.34313,849.86833,664.33824,849.74968,664.32848Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#2f2e41"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M871.60368,647.0775l-58.61914-65.23828a4.50392,4.50392,0,0,1-1.12744-3.48438l7.40332-69.40527a4.49279,4.49279,0,0,1,4.77368-4.01269l35.97583,2.39843a4.49985,4.49985,0,0,1,3.96363,5.93067l-21.55518,63.76758a3.48717,3.48717,0,0,0,.79712,3.55078l49.79273,51.60351a4.50015,4.50015,0,0,1-.949,6.999l-14.81909,8.75683a4.51037,4.51037,0,0,1-5.63648-.86621Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#2f2e41"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M827.66521,383.68s15-13,22-6c0,0,32.5,20.5,18.5,76.5,0,0,12,54,7,56s-55.5,9.5-59.5,3.5S809.66521,415.68,827.66521,383.68Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ff7e67"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M740.30326,430.21974l2.32172-14.12209a4.49983,4.49983,0,0,1,5.2872-3.689l44.61268,8.5507L840.219,405.69863a13.57916,13.57916,0,0,1,17.30317,9.61039l.0004-.00089a13.57861,13.57861,0,0,1-9.84233,16.48887l-54.332,13.71439-49.5089-10.15277a4.55367,4.55367,0,0,1-.9196-.29228A4.48577,4.48577,0,0,1,740.30326,430.21974Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ff7e67"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M842.60633,363.87051c2.2445-5.19456,4.14379-12.11252-.16123-15.78514-2.49712-2.13029-6.09384-2.13468-9.36546-2.39971-9.21731-.74669-18.70553-4.98771-23.21077-13.06356s-1.98923-20.08442,6.51023-23.728c5.72923-2.456,12.29743-.78291,18.29444.91767l18.0058,5.10593c5.35005,1.51712,10.96737,3.19025,14.81895,7.20148,6.14269,6.3973,5.68351,17.21167.80459,24.618S856.07654,361.868,847.66521,364.68Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#2f2e41"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M977.48017,686.68h-248a1,1,0,0,1,0-2h248a1,1,0,0,1,0,2Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M715.51983,213.32h-487a7.00778,7.00778,0,0,0-7,7v360a7.00778,7.00778,0,0,0,7,7h487a7.00778,7.00778,0,0,0,7-7v-360A7.00778,7.00778,0,0,0,715.51983,213.32Zm5,367a5.002,5.002,0,0,1-5,5h-487a5.002,5.002,0,0,1-5-5v-360a5.002,5.002,0,0,1,5-5h487a5.002,5.002,0,0,1,5,5Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 28.03998,
  width: 499,
  height: 2,
  fill: "#3f3d56"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 15,
  r: 6,
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.25,
  cy: 15,
  r: 6,
  fill: "#3f3d56"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 15,
  r: 6,
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M523.34267,524.62473a1,1,0,0,1-1-1v-41a1,1,0,0,1,2,0v41A1.00005,1.00005,0,0,1,523.34267,524.62473Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M521.97182,466.62473a.99478.99478,0,0,1-.50244-.13574l-56.81519-33.104a1.00019,1.00019,0,0,1,1.00684-1.72852l56.81518,33.104a1.00012,1.00012,0,0,1-.50439,1.86425Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M408.34364,466.62473a1.00012,1.00012,0,0,1-.50439-1.86425l56.81494-33.104A1.00019,1.00019,0,0,1,465.661,433.385l-56.815,33.104A.9994.9994,0,0,1,408.34364,466.62473Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M580.97182,516.62473a.99478.99478,0,0,1-.50244-.13574l-56.81519-33.104a1.00019,1.00019,0,0,1,1.00684-1.72852l56.81518,33.104a1.00012,1.00012,0,0,1-.50439,1.86425Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M467.34364,516.62473a1.00012,1.00012,0,0,1-.50439-1.86425l56.81494-33.104A1.00019,1.00019,0,0,1,524.661,483.385l-56.815,33.104A.99908.99908,0,0,1,467.34364,516.62473Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M465.34267,415.62473a.99984.99984,0,0,1-1-.99755L464.25014,378.24a.99989.99989,0,0,1,.99756-1.00244h.00244a.99985.99985,0,0,1,1,.99756l.09253,36.3872a.99989.99989,0,0,1-.99756,1.00244Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M478.27626,434.54075h-26.052a4.50508,4.50508,0,0,1-4.5-4.5V416.6594a4.50508,4.50508,0,0,1,4.5-4.5h26.052a4.50508,4.50508,0,0,1,4.5,4.5v13.38135A4.50508,4.50508,0,0,1,478.27626,434.54075Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M435.15761,366.52073H379.72414a1,1,0,0,1,0-2h55.43347a1,1,0,0,1,0,2Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M465.25014,352.23753a1.00005,1.00005,0,0,1-1-1v-34.6128a1,1,0,0,1,2,0v34.6128A1.00006,1.00006,0,0,1,465.25014,352.23753Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M358.15675,366.52073a.99564.99564,0,0,1-.50891-.13965l-53.81506-31.896a1.0001,1.0001,0,0,1,1.01977-1.72071l53.81507,31.896a1.00009,1.00009,0,0,1-.51087,1.86035Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M304.34364,398.41673a1.00009,1.00009,0,0,1-.51086-1.86036l53.81506-31.896a1.00009,1.00009,0,0,1,1.01978,1.7207l-53.81507,31.896A.99573.99573,0,0,1,304.34364,398.41673Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M375.72414,382.65061H362.34267a4.505,4.505,0,0,1-4.5-4.5V352.09886a4.505,4.505,0,0,1,4.5-4.5h13.38147a4.505,4.505,0,0,1,4.5,4.5v26.05175A4.505,4.505,0,0,1,375.72414,382.65061Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M478.27626,319.31565h-26.052a4.50508,4.50508,0,0,1-4.5-4.5V301.43382a4.50508,4.50508,0,0,1,4.5-4.5h26.052a4.50508,4.50508,0,0,1,4.5,4.5v13.38183A4.50508,4.50508,0,0,1,478.27626,319.31565Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M300.72414,351.65061H287.34267a4.505,4.505,0,0,1-4.5-4.5V321.09886a4.505,4.505,0,0,1,4.5-4.5h13.38147a4.505,4.505,0,0,1,4.5,4.5v26.05175A4.505,4.505,0,0,1,300.72414,351.65061Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M300.72414,414.65061H287.34267a4.505,4.505,0,0,1-4.5-4.5V384.09886a4.505,4.505,0,0,1,4.5-4.5h13.38147a4.505,4.505,0,0,1,4.5,4.5v26.05175A4.505,4.505,0,0,1,300.72414,414.65061Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M550.77626,366.52073H495.34267a1,1,0,0,1,0-2h55.43359a1,1,0,0,1,0,2Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M572.34364,366.52073a1,1,0,0,1-.51074-1.86035l53.81494-31.896a1,1,0,1,1,1.01953,1.72071l-53.81494,31.896A.99522.99522,0,0,1,572.34364,366.52073Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M626.15663,398.41673a.99531.99531,0,0,1-.50879-.13965l-53.81494-31.896a1,1,0,1,1,1.01953-1.7207l53.81494,31.896a1,1,0,0,1-.51074,1.86036Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#3f3d56"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M568.15761,382.65061H554.77626a4.50508,4.50508,0,0,1-4.5-4.5V352.09886a4.50508,4.50508,0,0,1,4.5-4.5h13.38135a4.50508,4.50508,0,0,1,4.5,4.5v26.05175A4.50508,4.50508,0,0,1,568.15761,382.65061Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M643.15761,351.65061H629.77626a4.50508,4.50508,0,0,1-4.5-4.5V321.09886a4.50508,4.50508,0,0,1,4.5-4.5h13.38135a4.50508,4.50508,0,0,1,4.5,4.5v26.05175A4.50508,4.50508,0,0,1,643.15761,351.65061Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M643.15761,414.65061H629.77626a4.50508,4.50508,0,0,1-4.5-4.5V384.09886a4.50508,4.50508,0,0,1,4.5-4.5h13.38135a4.50508,4.50508,0,0,1,4.5,4.5v26.05175A4.50508,4.50508,0,0,1,643.15761,414.65061Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M420.27614,485.54075h-26.052a4.505,4.505,0,0,1-4.5-4.5V467.6594a4.505,4.505,0,0,1,4.5-4.5h26.052a4.505,4.505,0,0,1,4.5,4.5v13.38135A4.505,4.505,0,0,1,420.27614,485.54075Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M536.0912,485.54075h-26.052a4.50508,4.50508,0,0,1-4.5-4.5V467.6594a4.50508,4.50508,0,0,1,4.5-4.5h26.052a4.50508,4.50508,0,0,1,4.5,4.5v13.38135A4.50508,4.50508,0,0,1,536.0912,485.54075Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M483.0912,534.54075h-26.052a4.50508,4.50508,0,0,1-4.5-4.5V516.6594a4.50508,4.50508,0,0,1,4.5-4.5h26.052a4.50508,4.50508,0,0,1,4.5,4.5v13.38135A4.50508,4.50508,0,0,1,483.0912,534.54075Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M594.0912,534.54075h-26.052a4.50508,4.50508,0,0,1-4.5-4.5V516.6594a4.50508,4.50508,0,0,1,4.5-4.5h26.052a4.50508,4.50508,0,0,1,4.5,4.5v13.38135A4.50508,4.50508,0,0,1,594.0912,534.54075Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M536.0912,534.54075h-26.052a4.50508,4.50508,0,0,1-4.5-4.5V516.6594a4.50508,4.50508,0,0,1,4.5-4.5h26.052a4.50508,4.50508,0,0,1,4.5,4.5v13.38135A4.50508,4.50508,0,0,1,536.0912,534.54075Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ccc"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M496.91933,382.91673H433.581a4.50508,4.50508,0,0,1-4.5-4.5v-25.792a4.50508,4.50508,0,0,1,4.5-4.5h63.33838a4.50508,4.50508,0,0,1,4.5,4.5v25.792A4.50508,4.50508,0,0,1,496.91933,382.91673Z",
  transform: "translate(-221.51983 -213.31996)",
  fill: "#ff7e67"
});

function SvgBuildAMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ed1cb2a2-9ed7-4833-8d03-c78f60f09f28",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 756.96034 473.36008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildAMethod);
export default __webpack_public_path__ + "static/media/build-a-method.ef5346e3.svg";
export { ForwardRef as ReactComponent };